<div class="charge-dialog">
  <div class="dialog-header">
    <div class="header-main">
      <div class="header-icon">
        <mat-icon>percent</mat-icon>
      </div>
      <div class="header-text">
        <h2>Update Platform Charge</h2>
        <p>New webinars created from today will use this rate.</p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="close-btn"
      (click)="onCancel()"
      [disabled]="isSubmitting"
      aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="context-card">
      <div class="context-row">
        <mat-icon>meeting_room</mat-icon>
        <div class="context-detail">
          <span class="context-label">Webinar room</span>
          <span class="context-value">{{ platformDto?.webinarRoom?.roomName }}</span>
        </div>
      </div>
      <div class="context-row">
        <mat-icon>person</mat-icon>
        <div class="context-detail">
          <span class="context-label">Host</span>
          <span class="context-value">{{ platformDto?.user?.firstName }} {{ platformDto?.user?.lastName }}</span>
        </div>
      </div>
      <div class="context-row">
        <mat-icon>history</mat-icon>
        <div class="context-detail">
          <span class="context-label">Current charge</span>
          <span class="context-value current-rate">{{ originalPercentage | number:'1.2-2' }}%</span>
        </div>
      </div>
    </div>

    <div class="input-section">
      <label class="input-label" for="platformChargeInput">New platform charge</label>
      <div class="percent-input-wrap" [class.has-value]="percentage != null">
        <input
          id="platformChargeInput"
          type="text"
          class="percent-input"
          [(ngModel)]="percentage"
          maxlength="5"
          (keypress)="onlyDecimalAllowed($event)"
          placeholder="0.00"
          [disabled]="isSubmitting"
          aria-label="Platform charge percentage" />
        <span class="percent-suffix">%</span>
      </div>
      <p class="input-hint">Enter a value between 0 and 99%</p>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button type="button" class="action-cancel" (click)="onCancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button
      mat-flat-button
      type="button"
      class="action-save"
      (click)="onUpdatePlatformCharge()"
      [disabled]="isSubmitting">
      <mat-spinner diameter="18" *ngIf="isSubmitting"></mat-spinner>
      <span>{{ isSubmitting ? 'Saving…' : 'Save changes' }}</span>
    </button>
  </div>
</div>
